import styled from "styled-components";

export const StyledTechSkillModal = styled.div`
  display: flex;
  flex-direction: column;
  height: 60vh;
  width: 60vw;
  @media (max-width: ${({ theme }) => theme.breakpoints.LG - 1}px) {
    width: 100%;
  }

  & .form-row {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    column-gap: 20px;
    row-gap: 20px;
    gap: 20px;

    &:first-child > section {
      max-width: 320px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
      flex-wrap: wrap;
      gap: 0px;

      &:first-child > section {
        max-width: unset;
      }
    }
  }
`;

export const StyledAlertMessage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
    & span {
      font-size: 9px;
    }
  }
`;
